/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: bbqin
 * @LastEditTime: 2022-05-16 17:18:57
 * @Description: file content
 */
import React, { Component } from 'react';
//import OriginPopover from 'bee-popover';
import { Popover as OriginPopover } from '@tinper/next-ui';
import { getSysFieldid, microAppUtil } from '@platform/api';
import './index.less';
//require('bee-popover/build/Popover.css');

/**
 * @namespace Popover
 */

/**
 * 气泡卡片 Popover 组件的参数描述
 * @memberof Popover
 * @component Popover
 * @property {ReactNode | function():ReactNode} content - 卡片内容
 * @property {ReactNode | function():ReactNode} title  - 卡片标题
 * @property {string} id  - 弹出层 id
 * @property {string} fieldid  - fieldid 前缀(如 fieldid_inner)【自动化测试专用属性】
 * @property {string} className  - 类名
 * @property {string} [placement=right]  - 弹出位置  可选 top left right bottom topLeft topRight bottomLeft bottomRight leftTop leftBottom rightTop rightBottom
 * @property {boolean} [inverse=false]  - 反白显示
 * @property {string|array} [trigger=['hover', 'focus']]  - 触发叠加层的事件 click  hover focus
 * @property {string|ReactNode|function():ReactNode} overlay  - 叠加层
 * @property {string} overlayClassName  - 叠加层类名
 * @property {CSSProperties} overlayStyle  - 叠加层样式
 * @property {CSSProperties} overlayInnerStyle  - 叠加层 inner 样式
 * @property {boolean} [overlayMaxHeight=false]  - 当内容区域超过屏幕可用高度时,设为 true 限制内容最大高度为可用高度,false 为内容实际高度
 * @property {boolean|object<keepParent:boolean>} [destroyTooltipOnHide=true]  - 关闭后是否销毁 Tooltip，当 keepParent 为 true 时销毁父容器
 * @property {boolean} defaultOpen  - 默认是否显示
 * @property {boolean} visible  - 是否控制弹出层的显示
 * @property {function} onOpenChange  - 使用控制弹出层显示时的钩子函数
 * @property {function} onHide  - 弹出层隐藏时的回调
 * @property {function(): triggerDomNode} [getPopupContainer= () => document.body]  - 浮层渲染父节点，默认渲染到 body 上
 * @property {number} [mouseEnterDelay= 0.5]  - 鼠标移入后延时多少才显示 Tooltip，单位：秒
 * @property {number} [mouseLeaveDelay= 0.1]  - 鼠标移出后延时多少才隐藏 Tooltip，单位：秒
 * @property {string} color  - 背景颜色
 * @property {boolean} [arrowPointAtCenter= false]  - 箭头是否指向目标元素中心
 * @property {boolean} [autoAdjustOverflow= true]  - 气泡被遮挡时自动调整位置
 */
export default class Popover extends Component {
    render() {
        let { fieldid, className, getPopupContainer, ...others } = this.props;
        return <OriginPopover
            overlayClassName={`${className + ' nc-popover'}`}
            {...others}
            fieldid={getSysFieldid(fieldid)}
            getPopupContainer={ typeof getPopupContainer === "function" ? getPopupContainer : null }
        />;
    }
}
